import React, { useState } from "react";
import DepartmentTable from "./table/departmentTable";
import AddDepartment from "./addDepartment";
import { Button, Group, SegmentedControl, Title } from "@mantine/core";
import { useGetUser } from "api/users/getUser";
import { PermissionButton } from "api/permission/buttonpermission";
import ProgramFeature from "features/program";

export default function Department() {
  const [opened, setOpened] = useState(false);
  const { data: user } = useGetUser();

  const [value, setValue] = useState<string>(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem("departmentView") ?? "department";
    }
    return "department";
  });

  const handleViewChange = (val: string) => {
    setValue(val);
    if (typeof window !== "undefined") {
      localStorage.setItem("departmentView", val);
    }
  };

  return (
    <div>
      <Group position="apart" align="center" mb="md">
        <div />
        <SegmentedControl
          value={value}
          onChange={handleViewChange}
          data={[
            { label: "Department", value: "department" },
            { label: "Program", value: "program" },
          ]}
        />
      </Group>

      {value === "department" && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 20,
            }}
          >
            <Title order={3}>Departments</Title>

            <PermissionButton
              permission="department.add"
              onClick={() => setOpened(true)}
            >
              Add Department
            </PermissionButton>
          </div>

          <DepartmentTable />
          <AddDepartment opened={opened} onClose={() => setOpened(false)} />
        </>
      )}

      {value === "program" && <ProgramFeature />}
    </div>
  );
}
